module.exports = __webpack_public_path__ + "static/media/text-size.abb39012.svg";